// extracted by mini-css-extract-plugin
export default {"slashCommandContainer":"SlashCommandsProvider-module__slashCommandContainer__T0XL0cq"};